module.exports = __webpack_public_path__ + "static/media/graphic_pattern.f15dc1b4.png";